/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthnContextUpdateChallengeOptions } from './AuthnContextUpdateChallengeOptions';
import {
    AuthnContextUpdateChallengeOptionsFromJSON,
    AuthnContextUpdateChallengeOptionsFromJSONTyped,
    AuthnContextUpdateChallengeOptionsToJSON,
} from './AuthnContextUpdateChallengeOptions';

/**
 * 
 * @export
 * @interface AuthnContextUpdateChallengeAllOf
 */
export interface AuthnContextUpdateChallengeAllOf {
    /**
     * 
     * @type {AuthnContextUpdateChallengeOptions}
     * @memberof AuthnContextUpdateChallengeAllOf
     */
    options: AuthnContextUpdateChallengeOptions;
}

/**
 * Check if a given object implements the AuthnContextUpdateChallengeAllOf interface.
 */
export function instanceOfAuthnContextUpdateChallengeAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function AuthnContextUpdateChallengeAllOfFromJSON(json: any): AuthnContextUpdateChallengeAllOf {
    return AuthnContextUpdateChallengeAllOfFromJSONTyped(json, false);
}

export function AuthnContextUpdateChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthnContextUpdateChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': AuthnContextUpdateChallengeOptionsFromJSON(json['options']),
    };
}

export function AuthnContextUpdateChallengeAllOfToJSON(value?: AuthnContextUpdateChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': AuthnContextUpdateChallengeOptionsToJSON(value.options),
    };
}

